// @ts-nocheck
import { GoogleMapProps } from "@react-google-maps/api";
import mergeProps from "@store/Framework/Common/Utilities/mergeProps";
import { useMemo } from "react";
import { useTheme } from "styled-components";

const useGoogleMapThemableProps = (extendedProps?: GoogleMapProps) => {
    const theme = useTheme();

    return useMemo(() => {
        return mergeProps(theme.googleMap.map, extendedProps);
    }, [theme.googleMap.map, extendedProps]);
};

export default useGoogleMapThemableProps;
